import { ArrowType, LineType } from '@ardoq/api-types';
import { SvgArrowName } from './types';

const ARROW_TYPE_TO_SVG_ARROW_NAME_LOOKUP: Record<
  ArrowType,
  SvgArrowName | undefined
> = {
  [ArrowType.NONE]: undefined,
  [ArrowType.BOTH]: SvgArrowName.BOTH,
  [ArrowType.BOTH_START]: SvgArrowName.BOTH,
  [ArrowType.BOTH_FILLED]: SvgArrowName.BOTH_FILLED,
  [ArrowType.BOTH_FILLED_START]: SvgArrowName.BOTH_FILLED,
  [ArrowType.BOTH_OUTLINED]: SvgArrowName.BOTH_OUTLINED,
  [ArrowType.BOTH_OUTLINED_START]: SvgArrowName.BOTH_OUTLINED,
  [ArrowType.BOTTOM]: SvgArrowName.BOTTOM,
  [ArrowType.BOTTOM_START]: SvgArrowName.BOTTOM,
  [ArrowType.CIRCLE]: SvgArrowName.CIRCLE,
  [ArrowType.CIRCLE_START]: SvgArrowName.CIRCLE,
  [ArrowType.DEFAULT]: SvgArrowName.DEFAULT,
  [ArrowType.DEFAULT_START]: SvgArrowName.DEFAULT,
  [ArrowType.DIAMOND]: SvgArrowName.DIAMOND_OUTLINED,
  [ArrowType.DIAMOND_START]: SvgArrowName.DIAMOND_OUTLINED,
  [ArrowType.DIAMOND_FILLED]: SvgArrowName.DIAMOND_FILLED,
  [ArrowType.DIAMOND_FILLED_START]: SvgArrowName.DIAMOND_FILLED,
  [ArrowType.MANY]: SvgArrowName.MANY,
  [ArrowType.MANY_START]: SvgArrowName.MANY,
  [ArrowType.ONE]: SvgArrowName.ONE,
  [ArrowType.ONE_START]: SvgArrowName.ONE,
  [ArrowType.ONE_MANDATORY]: SvgArrowName.ONE_MANDATORY,
  [ArrowType.ONE_MANDATORY_START]: SvgArrowName.ONE_MANDATORY,
  [ArrowType.ONE_OR_MANY]: SvgArrowName.ONE_OR_MANY,
  [ArrowType.ONE_OR_MANY_START]: SvgArrowName.ONE_OR_MANY,
  [ArrowType.TOP]: SvgArrowName.TOP,
  [ArrowType.TOP_START]: SvgArrowName.TOP,
  [ArrowType.ZERO_OR_MANY]: SvgArrowName.ZERO_OR_MANY,
  [ArrowType.ZERO_OR_MANY_START]: SvgArrowName.ZERO_OR_MANY,
  [ArrowType.ZERO_OR_ONE]: SvgArrowName.ZERO_OR_ONE,
  [ArrowType.ZERO_OR_ONE_START]: SvgArrowName.ZERO_OR_ONE,
};

export type ReferenceLinePreviewProps = {
  line?: LineType;
  width?: number;
  height?: number;
  color?: string;
  lineBeginning?: ArrowType;
  lineEnding?: ArrowType;
  style?: React.CSSProperties;
};

const getDashArray = (lineType: LineType) => {
  if (lineType === LineType.DASHED) return '12,6';
  if (lineType === LineType.DOTTED) return '2,4';
  return undefined;
};

export const ReferenceLinePreview = ({
  width = 72,
  height = 20,
  color = 'red',
  line = LineType.SOLID,
  lineBeginning = ArrowType.NONE,
  lineEnding = ArrowType.NONE,
  style,
}: ReferenceLinePreviewProps) => {
  const verticalMiddle = height / 2;
  // -1 and + 1 are just tiny offsets
  // so the line cap curves still fits
  // into the viewport
  const lineCapOffset = 1;
  const lineWidth = width - lineCapOffset;
  const lineStartOffset = lineCapOffset;
  const endArrow = ARROW_TYPE_TO_SVG_ARROW_NAME_LOOKUP[lineEnding];
  const startArrow = ARROW_TYPE_TO_SVG_ARROW_NAME_LOOKUP[lineBeginning];

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={style}
    >
      <path
        d={`M ${lineStartOffset} ${verticalMiddle} L ${lineWidth} ${verticalMiddle}`}
        fill="none"
        strokeWidth="2"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={getDashArray(line)}
        markerEnd={endArrow ? `url(#${endArrow}-end)` : undefined}
        markerStart={startArrow ? `url(#${startArrow}-start)` : undefined}
      ></path>
    </svg>
  );
};
